import React, { useEffect, useState } from "react";
import { AddToolTip } from "../../../components";
import { getInvestmentType } from "../../../services";
import { formFields, manageFeeFormNames } from "../../../utils";

const InvestmentSliderInformation = ({
  saveInvestment,
  investmentInfo,
  index,
  values,
  fields,
  setFieldValue,
  setSaveInvestment,
  setInvestmentTypes,
  investmentType,
  setInvestmentSelected,
  investmentSelected,
}) => {
  return (
    <div className="w-100 cardDetails" style={{ height: "54px" }}>
      <input
        style={{
          marginLeft: "15px",
          marginTop: "-7px",
          outline: "none",
        }}
        type="radio"
        checked={investmentInfo.id == investmentSelected}
        onClick={() => {
          setInvestmentSelected(investmentInfo.id);
        }}
        name={`inv${index}`}
      />
      {console.log("invest", investmentInfo)}
      <div
        className="ml-3"
        style={{
          width: "41.3%",
          marginTop: "10px",
          color: "#242426",
        }}
      >
        {investmentInfo?.name?.length < 20 ? (
          <div className="ft-16 fw-600">{investmentInfo?.name}</div>
        ) : (
          <>
            {investmentInfo?.name == null ? (
              <>{"-"}</>
            ) : (
              <>
                <AddToolTip
                  className="ft-16 fw-600"
                  name={investmentInfo?.name}
                >
                  {investmentInfo?.name.slice(0, 20)}...
                </AddToolTip>
              </>
            )}
          </>
        )}
      </div>

      {investmentInfo.cusip !== null ? (
        <div
          className=""
          style={{ width: "20.3%", marginTop: "10px", color: "#444446" }}
        >
          <div className="cusip-type">{investmentInfo.cusip}</div>
        </div>
      ) : (
        <div className="" style={{ width: "20.3%" }}>
          <div className="cusip-type">{"-"}</div>
        </div>
      )}

      <div className="mb-3" style={{ marginTop: "10px", color: "#444446" }}>
        <div className="ft-14 fw-500">
          {
            investmentType?.filter((item) => item.id == investmentInfo.type)[0]
              ?.name
          }
        </div>
      </div>
    </div>
  );
};

export default InvestmentSliderInformation;
